import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Look in both hash and query — different browser/referrer-policy combos
    // surface the OAuth session_id in either spot.
    const hash = window.location.hash || "";
    const search = window.location.search || "";
    let match = hash.match(/session_id=([^&]+)/);
    if (!match) match = search.match(/session_id=([^&]+)/);

    if (!match) {
      window.history.replaceState(null, "", "/");
      window.location.replace("/");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        // Strip the session_id fragment AND query from the URL before reload.
        window.history.replaceState(null, "", "/dashboard");
        window.location.replace("/dashboard");
      } catch (err) {
        // Log so we can diagnose if the loop ever recurs.
        // eslint-disable-next-line no-console
        console.error("[auth] session exchange failed", err?.response?.status, err?.response?.data);
        window.history.replaceState(null, "", "/?auth_error=1");
        window.location.replace("/?auth_error=1");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F5EE] text-[#1A1F2C] flex items-center justify-center">
      <p className="font-serif text-2xl">Signing you in&hellip;</p>
    </div>
  );
}
